import React from 'react';
import { MdBuildCircle, MdInfo } from 'react-icons/md';
import { HStack, IconButton, Tooltip } from '@chakra-ui/react';

export const DetailsButtons: React.FC<{
  setShowDetails: ({ show, id }: { show: boolean; id: string }) => void;
  setShowItens: ({ show, id }: { show: boolean; id: string }) => void;
  id: string;
}> = ({ setShowDetails, setShowItens, id }) => (
  <HStack>
    <Tooltip label="Informações" bg="button" color="white" borderRadius="4px">
      <IconButton
        h="100%"
        minW={0}
        size="lg"
        variant="ghost"
        icon={<MdInfo />}
        onClick={() => setShowDetails({ show: true, id: id })}
        aria-label="Informações"
        color="button"
      />
    </Tooltip>
    <Tooltip
      label="Detalhes do serviço"
      bg="button"
      color="white"
      borderRadius="4px"
    >
      <IconButton
        h="100%"
        minW={0}
        size="lg"
        variant="ghost"
        icon={<MdBuildCircle />}
        onClick={() => setShowItens({ show: true, id: id })}
        aria-label="Detalhes do serviço"
        color="button"
      />
    </Tooltip>
  </HStack>
);
